'use strict';

import Cookies from 'js-cookie';

export default class Navigation {
  constructor() {
    this.selectors = {
      header: $('header'),
      banner: $('header .header-banner'),
      banner_close: $('header .header-banner-link-close'),
      dropdown_menus: $('.main-navigation ul.dropdown-menu'),
      top_level_dropdowns: $('.main-navigation li.depth-0.dropdown'),
      top_level_dropdowns_mobile: $('.main-navigation li.depth-0.dropdown > a.dropdown-toggle'),

      toggler: $('.main-navigation button.navbar-toggler'),
      menu: $('.main-navigation #navbarNavDropdown'),
      back: $('.main-navigation li.mobile-back'),
      dropdown_menu: $('.main-navigation ul.dropdown-menu'),
    };

    this.init_header_scroll();
    this.init_desktop();
    this.init_mobile();
    this.init_banner();
  }

  delay_mouse_enter() {
    let _self = this;
    let dropdowns = _self.selectors.top_level_dropdowns;

    dropdowns.each(function () {
      let dropdown = $(this);
      let timeoutId;
      dropdown.on('mouseenter', function () {
        timeoutId = setTimeout(() => {
          // callback(event, menu);

          _self.selectors.header.addClass('active');

          $('> a.dropdown-toggle', $(this)).attr('aria-expanded', true);
          let menu = $('> ul.dropdown-menu', $(this));
          menu.css('height', 'auto');
          menu.addClass('show');


          // If there's not enough vertical height in the viewport to fit the dropdown,
          // set the height of the dropdown to make it scroll vertically.
          let menu_offset_top = menu.offset().top - $(window).scrollTop();
          if (menu_offset_top + menu.outerHeight() > $(window).height()) {
            let new_height = $(window).height() - menu_offset_top - parseInt(menu.css('padding-top')) - parseInt(menu.css('padding-bottom'));
            menu.height(new_height);
          }
        }, 250);
      });
      dropdown.on('mouseleave', function () {
        clearTimeout(timeoutId);
      });
    });
  }

  delay_mouse_leave() {
    let _self = this;
    let dropdowns = _self.selectors.top_level_dropdowns;

    dropdowns.each(function () {
      let dropdown = $(this);
      let timeoutId;

      dropdown.on('mouseleave', function () {
        timeoutId = setTimeout(() => {
          // callback(event, menu);

          _self.selectors.header.removeClass('active');

          let menu = $('> ul.dropdown-menu', $(this));
          menu.removeClass('show');
          menu.css('height', 'auto');

          $('> a.dropdown-toggle', $(this)).attr('aria-expanded', false);

        }, 250);
      });

      dropdown.on('mouseenter', function () {
        clearTimeout(timeoutId);
      });
    });
  }

  menuMouseEnter(event, menu) {
    let _self = menu;
    _self.selectors.header.addClass('active');

    $('> a.dropdown-toggle', $(this)).attr('aria-expanded', true);
    $('> ul.dropdown-menu', $(this)).addClass('show');
  }

  /**
   * Check if element is in viewport
   *
   * @param  HTMLElement el
   * @return boolean
   */
  _is_in_viewport(el) {
    var rect = el.getBoundingClientRect();

    return (
      //rect.top >= 0 &&
      rect.left >= 0 &&
      //rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  /**
   * Header scroll
   *
   * Hide on scroll down, reveal on scroll up
   */
  init_header_scroll() {
    let that = this;
    let header = document.getElementsByTagName('header')[0];

    window.addEventListener('scroll', () => {
      let scroll_top = window.pageYOffset || document.documentElement.scrollTop;

      if (scroll_top > 0) {
        if (!header.classList.contains('scrolled')) {
          header.classList.add('scrolled');
          if (!that.selectors.banner.hasClass('sticky')) {
            that.selectors.banner.slideUp();
          }
        }
      } else {
        header.classList.remove('scrolled');
        if (!that.selectors.banner.hasClass('sticky')) {
          that.selectors.banner.slideDown();
        }
      }
    });
  }

  /**
   * Init desktop
   *
   */
  init_desktop() {
    let _self = this;
    _self.init_desktop_menus();

    $(window).on('load resize orientationchange', () => {
      _self.init_desktop_menus();
    });
  }

  init_desktop_menus() {
    let _self = this;

    if (window.innerWidth > 1024) {
      // let container = $('.container')[0].getBoundingClientRect();
      const container = $('.main-wrapper').find('.container').first();

      // console.log("container: ", container);
      $('> ul.dropdown-menu', _self.selectors.top_level_dropdowns).each(function () {
        let menu = $(this);
        menu[0].style.removeProperty('left');

        if (!menu.hasClass('is-full-width')) {
          // Auto align
          // if (_self._is_in_viewport(menu[0]) || true) {
          if (menu.outerWidth() < container.width()) {
            const linkCenterPoint = menu.parent().position().left + (menu.parent().outerWidth() / 2);
            let menuLeft = linkCenterPoint - (menu.outerWidth() / 2);
            if (menuLeft < 0)
              menuLeft = 0;
            if (menuLeft + menu.outerWidth() > container.outerWidth())
              menuLeft = container.outerWidth() - menu.outerWidth() - 15;
            menu.css('left', menuLeft);
          } else {
            // Align dropdown to right edge of container
            menu.css('left', container.position.left);
          }
          // }
        }
      });

      // Show menu
      _self.delay_mouse_enter();

      // Hide menu
      _self.delay_mouse_leave();

    } else {
      _self.selectors.top_level_dropdowns.off('mouseenter mouseleave');
      _self.selectors.dropdown_menu.on('click', (e) => {
        e.stopPropagation();
      });
    }
  }

  /**
   * Mobile
   *
   */
  init_mobile() {
    let _self = this;

    this.selectors.toggler.on('click', () => {
      if (_self.selectors.toggler.attr('aria-expanded') == 'true') {
        $('html').removeClass('menu-open');

        _self.selectors.header.removeClass('menu-open');
        _self.selectors.menu.removeClass('submenu-active');
      } else {
        _self.selectors.header.addClass('menu-open');
        $('html').addClass('menu-open');
      }
    });

    this.selectors.top_level_dropdowns_mobile.on('click', function (e) {
      _self.selectors.menu.addClass('submenu-active').removeClass('submenu-closed');
      if ($(window).outerWidth() > 1023) {
        e.stopPropagation();
      }
    });

    // Back to main menu
    this.selectors.back.on('click', function () {
      let _el = $(this);

      _self.selectors.menu.removeClass('submenu-active').addClass('submenu-closed');

      setTimeout(function () {
        _el.closest('.dropdown-menu').removeClass('show').prev('.dropdown-toggle').attr('aria-expanded', false);
      }, 200);
    });
  }

  init_banner() {
    let that = this;
    if (this.selectors.banner.length > 0) {
      let post_id = this.selectors.banner.data('post-id');
      let $link = this.selectors.banner.find('.button-a');
      let text = this.selectors.banner.find('.header-banner-text').text().trim();
      const re = /header-banner-([^ ]+)-gradient/;
      const matches = this.selectors.banner.attr('class').match(re);
      let bgColor = '';
      if (true === Array.isArray(matches) && matches.length > 0) {
        bgColor = matches[1];
      }
      var cookie_value = 'ontra-promo-hide-' + post_id;
      if (this.selectors.banner.hasClass('header-banner-global')) cookie_value = 'ontra-promo-hide-global';

      // Compare and see if the current url visited is same as the "link href". If it is... then don't show the Promo-banner.
      var sameURL = false;
      if (window.location.href === $link.attr('href')) {
        sameURL = true;
      }

      // Save a cookie that this alert should be hidden, with the post id and a hash of the link contents
      this.selectors.banner_close.on('click', function (e) {
        e.preventDefault();
        var hash = text + ':' + $link.text() + ':' + $link.attr('href') + ':' + bgColor;
        // Cookies.set(cookie_value, hash, { expires: 30 }); // makes the cookie expire in 30 days.
        // Cookies.set(cookie_value, hash, { }); // makes the cookie 'expire right away / session' after the user closes the browser, the promo-banner will show again.
        Cookies.set(cookie_value, hash, {});
        that.selectors.banner.slideUp('slow', function () {
          that.selectors.banner.remove();
        });
      });

      // See if this alert should be hidden, but only if the contents of the cookie for this post matches the link contents
      let cookie = Cookies.get(cookie_value);
      if (cookie) {
        let hash = text + ':' + $link.text() + ':' + $link.attr('href') + ':' + bgColor;
        if (cookie.localeCompare(hash) !== 0) {
          Cookies.remove(cookie_value);
          //If the current visited url not the same url as the one in the PROMO link.href then, show the banner.
          if (!sameURL) {
            this.selectors.banner.slideDown('slow');
          }
        } else {
          this.selectors.banner.addClass('d-none');
        }
      } else {
        //If the current visited url not the same url as the one in the PROMO link.href then, show the banner.
        if (!sameURL) {
          this.selectors.banner.slideDown('slow');
        }
      }
    }
  }
}
